<app-page-header>
  <ng-template #headerBarControlsTemplate>
    <!-- Template ref Needed for content child directive -->
    <button
      kendoButton
      class="k-ml-22 !k-pr-4"
      themeColor="secondary"
      (click)="openCreateInvoiceDialog()"
      size="large"
    >
      <span class="custom-symbol add turquoise k-mr-3"></span>
      Neue Ausgangsrechnung
    </button>
  </ng-template>
</app-page-header>

<div class="card-wrapper">
  <div class="card">
    <div class="card-body">
      <div class="k-w-full">
        <app-shive-grid #gridWrapperComponent [grid]="grid">
          <kendo-grid
            #grid
            [kendoGridBinding]="gridData"
            kendoGridSelectBy="id"
            scrollable="none"
            size="medium"
            (cellClick)="onCellClick($event)"
            [pageSize]="20"
            [selectable]="{ enabled: true, checkboxOnly: true }"
            [columnMenu]="{ filter: true }"
          >
            <kendo-grid-checkbox-column
              [width]="60"
              [headerClass]="{ 'k-text-center': true }"
              [class]="{ 'k-text-center': true }"
              [resizable]="false"
              [columnMenu]="false"
              [showSelectAll]="true"
            ></kendo-grid-checkbox-column>

            <kendo-grid-column field="invoice_name" title="Rechnungsname">
              <ng-template kendoGridCellTemplate let-invoice>
                <div class="invoice-title">{{ findKvRecordValue(invoice.meta, TitleMetaKey) }}</div>
              </ng-template>
            </kendo-grid-column>

            <!--            <kendo-grid-column field="invoice_name" title="PDF">-->
            <!--              <ng-template kendoGridCellTemplate let-invoice>-->
            <!--                <a [attr.href]="invoice.pdfUrl" target="_blank" rel="noopener">PDF</a>-->
            <!--              </ng-template>-->
            <!--            </kendo-grid-column>-->

            <kendo-grid-column field="contextMenu" title="" [columnMenu]="false" [width]="60">
              <ng-template kendoGridCellTemplate let-invoice>
                <app-context-menu-anchor
                  [dataItem]="invoice"
                  [gridWrapperComponent]="gridWrapperComponent"
                />
              </ng-template>
            </kendo-grid-column>
          </kendo-grid>
        </app-shive-grid>
      </div>
    </div>
  </div>
</div>
